export default __webpack_public_path__ + "dbb1a5d24bed2b31e06462ff9952fbb9.png";